interface ColumnEnumItem {
    value: string
    label: string
}

export default class ColumnEnum {
    private _itens: Array<ColumnEnumItem>

    constructor(obj: Array<ColumnEnumItem>) {
        if (ColumnEnum.isColumnEnum(obj)) {
            this._itens = obj.itens
        } else {
            this._itens = obj
        }
    }

    public get itens() {
        return this._itens
    }

    public static isColumnEnum(value?: any) {
        return value instanceof ColumnEnum
    }
}
